"use client";

import { useSearchParams } from "next/navigation";
import { FinancialAdmin } from "@/app/service/[id]/FinancialAdmin";
import { FirstResponder } from "@/app/service/[id]/FirstResponder";

const SERVICE_ID_PLACEHOLDER = "cmjcrj5ad000gg8xz8icco4jr";

export default function ServiceDetailInline({
  serviceId,
  containerWidth,
}: {
  serviceId: string;
  containerWidth?: number;
}) {
  const searchParams = useSearchParams();
  const source = searchParams?.get("source");
  const isAfterHireView = source === "order";

  if (isAfterHireView) {
    if (serviceId === SERVICE_ID_PLACEHOLDER) {
      return (
        <FinancialAdmin
          serviceId={serviceId}
          containerWidth={containerWidth}
        />
      );
    }
    return <FirstResponder serviceId={serviceId} />;
  }

  return <FirstResponder serviceId={serviceId} />;
}

